const getEnvVar = (key: string) => {
	if (process.env[key] === undefined) {
		throw new Error(`Env variable ${key} is required`);
	}
	return process.env[key] || '';
};

export const API_SERVER_URL = getEnvVar('REACT_APP_SERVER_URL');
export const API_SERVER_URL_V2 = getEnvVar('REACT_APP_SERVER_URL_V2');
export const WEBAPP_KEY = getEnvVar('REACT_APP_WEBAPP_KEY');
export const WEPAPP_DOMAIN = getEnvVar('REACT_APP_WEPAPP_DOMAIN');
export const WEBAPP_DEV_KEY = getEnvVar('REACT_APP_WEBAPP_DEV_KEY');
export const WEPAPP_DEV_DOMAIN = getEnvVar('REACT_APP_WEPAPP_DEV_DOMAIN');
export const WEPAPP_STAGE_DOMAIN = getEnvVar('REACT_APP_WEPAPP_STAGE_DOMAIN');
export const WEPAPP_SUPPORT_DOMAIN = getEnvVar('REACT_APP_WEBAPP_SUPPORT_DOMAIN');